import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for   Squareoffvalues
export const Squareoffvalues = createSlice({
  name: "Squareoffvalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    Squareoffvalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_Squareoffvalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_Squareoffvalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    Squareoffvalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_Squareoffvalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchSquareoffvalues:(state)=>{
        state.switch = false
    }
  },
});
export default Squareoffvalues.reducer;
export const {
  Squareoffvalues_datagrid,
  success_api_call_Squareoffvalues_datagrid,
  failure_api_call_Squareoffvalues_datagrid,
  create_Squareoffvalues_datagrid_complete_api,
  Squareoffvalues_datagrid_is_success,false_switchSquareoffvalues
} = Squareoffvalues.actions;
